const PROCESS_STEPS = [
  { num: "01", title: "Walkthrough & seal", body: "We inspect your system, lay drop cloths, and protect floors and furniture." },
  { num: "02", title: "Negative pressure setup", body: "Industrial HEPA vacuum is connected directly to your trunk line." },
  { num: "03", title: "Agitate every line", body: "Rotary brushes and air whips dislodge debris in every supply and return." },
  { num: "04", title: "Capture & verify", body: "Material is pulled under continuous negative pressure into sealed containment." },
  { num: "05", title: "Optional sanitization", body: "EPA-registered antimicrobial fog neutralizes mold, bacteria, and odors." },
  { num: "06", title: "Before / after photos", body: "You receive a digital report with photos and recommended maintenance." },
  { num: "07", title: "Walkthrough sign-off", body: "We don't leave until you're satisfied. Period." },
];

const TECH_IMG = "https://images.pexels.com/photos/32588555/pexels-photo-32588555.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function ProcessSection() {
  return (
    <section className="section-pad" data-testid="process-section">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="rounded-3xl overflow-hidden card-surface">
            <img src={TECH_IMG} alt="Technician performing duct cleaning" className="w-full h-[460px] object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="eyebrow mb-3">The Full Indoor Air Method</div>
          <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-medium">
            Seven steps. Photo proof. No surprises.
          </h2>
          <div className="mt-10 space-y-6">
            {PROCESS_STEPS.map((s) => (
              <div key={s.num} className="flex gap-5 border-b border-black/5 pb-5">
                <div className="font-heading text-clay text-lg w-12 shrink-0">{s.num}</div>
                <div>
                  <div className="font-heading text-lg tracking-tight">{s.title}</div>
                  <div className="text-muted2 text-sm mt-1">{s.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
